<p-table [value]="generalInfo" [columns]="generalInfoColumns" data-test-id="facility-table">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th>
          <label [class.field-required]="col.field === 'network'">
            {{ col.header }}
          </label>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-facilityInfo let-columns="columns">
    <tr>
      @for (col of columns; track col) {
        @switch (col.field) {
          @case ('outOfNetwork') {
            <td [class.attention-mark]="facilityInfo[col.field]">
              <div class="text-center">
                <p-checkbox [binary]="true" [disabled]="true" data-test-id="out-of-network-checkbox"
                [ngModel]="facilityInfo[col.field]"></p-checkbox>
              </div>
            </td>
          }
          @case ('isGoldCardProvider') {
            <td [class.attention-mark]="facilityInfo[col.field]">
              <div class="text-center">
                <p-checkbox [binary]="true" [disabled]="true" data-test-id="gold-card-provider-checkbox"
                [ngModel]="facilityInfo[col.field]"></p-checkbox>
              </div>
            </td>
          }
          @case ('goldCardAuthType') {
            <td [class.attention-mark]="facilityInfo[col.field]">
              <div class="text-center">
                {{ facilityInfo[col.field] | emptyPlaceholder }}
              </div>
            </td>
          }
          @default {
            <td>{{ facilityInfo[col.field] | emptyPlaceholder }}</td>
          }
        }
      }
    </tr>
  </ng-template>
</p-table>